const typeStation = 'STATION'

const overlay = {
    typeStation
}

export default overlay